// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2M8C3","location":"Header_location__317zZ"};